import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { cargarInstancia } from './utils/instancia';

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// Primero los ajustes de esta instalación (moneda, IVA... del país); luego la aplicación
const root = ReactDOM.createRoot(document.getElementById('root'));
cargarInstancia().finally(() => root.render(<React.StrictMode><App /></React.StrictMode>));
